import { bool, objectOf, arrayOf, shape, string, number, oneOfType, oneOf } from 'prop-types';
import { BADGES, TYPES } from '../utils';

const CategoryUrlParamsProps = {
    id: number.isRequired,
};

const SubCategoryUrlParamsProps = {
    id: number.isRequired,
    categoryId: number.isRequired,
};

const NestedSubCategoryUrlParamsProps = {
    id: number.isRequired,
    categoryId: number.isRequired,
    nestedSubCategoryId: number.isRequired,
};

const SearchQueryUrlParamsProps = {
    queryParamsProps: string.isRequired,
};

const StoreUrlParamsProps = {
    slug: string.isRequired,
};

const FilterPageParamsProps = {
    id: number.isRequired,
    categoryId: number.isRequired,
    filterId: string.isRequired,
};

const ConfigMenuItemProps = shape({
    id: string.isRequired,
    displayName: string.isRequired,
    alias: string,
    badge: oneOf(Object.values(BADGES)),
    isTitle: bool,
    type: oneOf(Object.values(TYPES)),
    urlParams: oneOfType([
        shape(CategoryUrlParamsProps),
        shape(SubCategoryUrlParamsProps),
        shape(NestedSubCategoryUrlParamsProps),
        shape(SearchQueryUrlParamsProps),
        shape(StoreUrlParamsProps),
        shape(FilterPageParamsProps),
    ]),
});

const ConfigLevelProps = objectOf(arrayOf(ConfigMenuItemProps));

export { ConfigMenuItemProps, ConfigLevelProps };
